import ResizeObserver from 'resize-observer-polyfill';
import utils from '@/_modules/utils';
import gnav from '@/_modules/common/gnav';
import alertModal from '@/_modules/common/alertModal';
import footer from '@/_modules/common/footer';
import loading from '@/_modules/common/loading';
// contact
import contactForm from '@/_modules/contactForm';

export default class pageContact {
  constructor() {
    
    this.getHeight100();
    this.winH = 0;
    this.conH = 0;

    loading.once();
    gnav.once();
    footer.once();
    alertModal.once();

    this.init();
  }

  init() {
    this.resizeObserver = new ResizeObserver(this.resize.bind(this));
    this.resizeObserver.observe(document.body);

    const vNames = {
      'name': {
        name: 'お名前',
        rule: [
          'required',
          'max:150'
        ],
        type: 'text',
      },
      'kana': {
        name: 'フリガナ',
        rule: [
          'required',
          'max:150'
        ],
        type: 'text',
      },
      // 'company': {
      //   name: '会社名',
      //   rule: [
      //     'required',
      //     'max:250'
      //   ],
      //   type: 'text',
      // },
      'email': {
        name: 'メールアドレス',
        rule: [
          'required',
          'email',
          'max:250'
        ],
        type: 'text',
      },
      'tel': {
        name: '電話番号',
        rule: [
          'required',
          'max:30'
        ],
        type: 'text',
      },
      'message': {
        name: 'お問い合わせ内容',
        rule: [
          'required',
          'max:10000'
        ],
        type: 'textarea',
      },
      'consent': {
        name: '同意する',
        rule: [
          'required_arr'
        ],
        type: 'checkbox',
      }
    };
    this.contactForm = contactForm.once(vNames);
  }

  start() {
    gnav.start();
    alertModal.start();
  }

  getHeight100() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  resize(entries) {
    gnav.resize();
    footer.resize();
  }

  scroll(e) {
    let scrollY = utils.getScrollTop();
  }
}